module.exports = require("net");


//////////////////
// WEBPACK FOOTER
// external "net"
// module id = 195
// module chunks = 0